//Global exports for API endpoints for EAYard API Gateway
//module.exports.endpoint = 'http://localhost:3002/api/v1/CXScoreCardInsurance';

//Use this entry for hosting on GuRue Consulting or main website adjust accordingly
//exports.loginUser = 'http://consent.gurueconsulting.com/api/v1/Consent/login';
//exports.getUserSalt = 'http://consent.gurueconsulting.com/api/v1/Consent/getUserSalt';
//exports.tenants = 'http://consent.gurueconsulting.com/api/v1/Consent/tenants';

//exports.loginUser = 'http://192.168.2.147:3002/api/v1/CXScoreCardInsurance/login';
//Use this entry when testing locally with API Gateway running on Local Host
exports.loginUser = 'https://consent.tattooreleaseonline.com/api/v1/Consent/login';
exports.getUserSalt = 'https://consent.tattooreleaseonline.com/api/v1/Consent/getUserSalt';
exports.loginKioskUser = 'https://consent.tattooreleaseonline.com/api/v1/Consent/loginkioskuser';
exports.getKioskUserSalt = 'https://consent.tattooreleaseonline.com/api/v1/Consent/getkioskusersalt';
exports.tenants = 'https://consent.tattooreleaseonline.com/api/v1/Consent/tenants';
exports.artists = 'https://consent.tattooreleaseonline.com/api/v1/Consent/tenants/artists';
exports.artist = 'https://consent.tattooreleaseonline.com/api/v1/Consent/tenants/artist';
exports.clauses = 'https://consent.tattooreleaseonline.com/api/v1/Consent/tenants/clauses';
exports.clause = 'https://consent.tattooreleaseonline.com/api/v1/Consent/tenants/clause';
exports.consents = 'https://consent.tattooreleaseonline.com/api/v1/Consent/tenants/consents';
exports.consent = 'https://consent.tattooreleaseonline.com/api/v1/Consent/tenants/consent';
exports.kioskusers = 'https://consent.tattooreleaseonline.com/api/v1/Consent/tenants/kioskusers';
exports.kioskuser = 'https://consent.tattooreleaseonline.com/api/v1/Consent/tenants/kioskuser';
exports.includedartists = 'https://consent.tattooreleaseonline.com/api/v1/Consent/tenants/consent/artists';
exports.includedartistscombined = 'https://consent.tattooreleaseonline.com/api/v1/Consent/tenants/consent/artists/combined';
exports.includedartist = 'https://consent.tattooreleaseonline.com/api/v1/Consent/tenants/consent/artist';
exports.includedclauses = 'https://consent.tattooreleaseonline.com/api/v1/Consent/tenants/consent/clauses';
exports.includedclausescombined = 'https://consent.tattooreleaseonline.com/api/v1/Consent/tenants/consent/clauses/combined';
exports.includedclause = 'https://consent.tattooreleaseonline.com/api/v1/Consent/tenants/consent/clause';
exports.submissions = 'https://consent.tattooreleaseonline.com/api/v1/Consent/submissions';
exports.submission = 'https://consent.tattooreleaseonline.com/api/v1/Consent/submissions/submission';
exports.register = 'https://consent.tattooreleaseonline.com/api/v1/Consent/register';
exports.subscriptions = 'https://consent.tattooreleaseonline.com/api/v1/Consent/subscriptions';
exports.subscription = 'https://consent.tattooreleaseonline.com/api/v1/Consent/subscriptions/subscription';
exports.sendmail = 'https://consent.tattooreleaseonline.com/api/v1/Consent/sendmail';

//General API key for accessing server side REST calls via apigateway
exports.apiKey = '9d61a8fc-3376-4234-ae3e-c194d7d4bd34';

//Subscription Rates
exports.Monthly = 99;
exports.Yearly = 1070;
exports.MultiShop = 40;
exports.email = "tattooreleaseonline@gmail.com";




// WEBPACK FOOTER //
// ./src/API/api.js